import Button from "@edaz/edazkit/Button/index";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView, View } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import React from "react";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import Modal from "react-bootstrap/Modal";
import FuelTypeChangeViewModel from "viewModels/callCenter/search/charges/fuelTypeChangeRefundViewModel";
import { translateGeneral } from "utils/localizations";
import { FuelTypeChangeForm } from "./fuelTypeChangeForm";
import RefundPreview from "../refund/refundPreview";
import RefundInformationPanel from "../refundInformationPanel";

const FuelTypeChangeView: ViewComponent<FuelTypeChangeViewModel> = observer(({ vm }) => {
  if (!vm.item) {
    return null;
  }

  return (
    <Modal show={true} onHide={vm.onClose} dialogClassName="modal-md" centered>
      <Modal.Header closeButton={true}>
        <Modal.Title>{vm.translate("name")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <RefundInformationPanel vm={vm} />
        <View vm={vm.alertsViewModel} useLifecycle={true} />
        <LoaderOverlay loading={vm.busyWatcher.isBusy}>
          {vm.secondStep ? <RefundPreview vm={vm} /> : <FuelTypeChangeForm vm={vm} />}
        </LoaderOverlay>
        <ButtonToolbar className="justify-content-center">
          {vm.secondStep ? (
            <Button size="sm" type="reset" onClick={vm.onBackClick} variant="light">
              {translateGeneral("back")}
            </Button>
          ) : (
            <Button size="sm" type="reset" onClick={vm.onClose} variant="light">
              {translateGeneral("cancel")}
            </Button>
          )}
          <Button
            size="sm"
            type="submit"
            onClick={vm.onSubmit}
            disabled={
              !!vm.rejectedReason ||
              (!vm.isAllowedToChangePaymentInformation && vm.paymentInformationRequired && !!vm.changeWithRefund)
            }>
            {vm.saveButtonText}
          </Button>
        </ButtonToolbar>
      </Modal.Body>
    </Modal>
  );
});

registerView(FuelTypeChangeView, FuelTypeChangeViewModel);
